/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./code.vue?vue&type=template&id=b7a97b1e&scoped=true"
import script from "./code.vue?vue&type=script&lang=js"
export * from "./code.vue?vue&type=script&lang=js"
import style0 from "./code.vue?vue&type=style&index=0&id=b7a97b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a97b1e",
  null
  
)

export default component.exports